var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenNewTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33569",
    "data-name": "Group 33569",
    transform: "translate(126 136) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(108 118)",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(343.73 227.903) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72245",
    "data-name": "Path 72245",
    d: "M225.931,92.9h-4a3.2,3.2,0,0,0-3.2,3.2v9.6a3.2,3.2,0,0,0,3.2,3.2h9.6a3.2,3.2,0,0,0,3.2-3.2v-4a.8.8,0,1,0-1.6,0v4a1.6,1.6,0,0,1-1.6,1.6h-9.6a1.6,1.6,0,0,1-1.6-1.6V96.1a1.6,1.6,0,0,1,1.6-1.6h4a.8.8,0,1,0,0-1.6ZM232,94.5h-2.869a.8.8,0,0,1,0-1.6h4.8a.8.8,0,0,1,.8.8v4.8a.8.8,0,1,1-1.6,0V95.634l-5.834,5.834a.8.8,0,1,1-1.131-1.131Z",
    fill: "#5076ba",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewTab);
export default __webpack_public_path__ + "static/media/open-new-tab.75f0e5b122b5ac0751b173747fce13d6.svg";
export { ForwardRef as ReactComponent };